module.exports = __webpack_public_path__ + "img/civil.68557008.png";